import dayjs, { type Dayjs } from "dayjs"

import type { PerformanceGrain } from "./types"

// Period keys are the server's: 2026-09 | 2026-Q3 | 2026.
export const periodKeyToDate = (
  grain: PerformanceGrain,
  key?: string
): Dayjs | null => {
  if (!key) return null
  if (grain === "month" && /^\d{4}-\d{2}$/.test(key)) return dayjs(`${key}-01`)
  const quarter = /^(\d{4})-Q([1-4])$/.exec(key)
  if (grain === "quarter" && quarter) {
    return dayjs(new Date(Number(quarter[1]), (Number(quarter[2]) - 1) * 3, 1))
  }
  if (grain === "year" && /^\d{4}$/.test(key)) return dayjs(`${key}-01-01`)
  return null
}

export const dateToPeriodKey = (
  grain: PerformanceGrain,
  date: Dayjs
): string => {
  if (grain === "month") return date.format("YYYY-MM")
  if (grain === "quarter")
    return `${date.year()}-Q${Math.floor(date.month() / 3) + 1}`
  return String(date.year())
}
